import React from "react";
import ClosePayable from "../../../common/poppers/ClosePayable";
import DeleteObject from "../../../common/poppers/DeleteObject";
import GroupForPayable from "../../../common/poppers/GroupForPayable";
import ManualMatcherForPayable from "../../../common/poppers/ManualMatcherForPayable";
import Matcher from "../../../common/poppers/MatcherForPayable";
import PayableDetail from "../../../common/poppers/details/PayableDetail";
import WiredObject from "../../../common/poppers/WiredObject";
import IncomingBillRow from "./IncomingBillRow";
import ModifyIncoming from "./ModifyIncoming";
import RemovePayableFromGroup from "../../../common/poppers/RemovePayableFromGroup";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import LinkIcon from "@material-ui/icons/Link";
import LinkOffIcon from "@material-ui/icons/LinkOff";
import BeenhereIcon from "@material-ui/icons/Beenhere";
import NewCarInsurance from "../../car/car/NewCarInsurance";

export const incomingBillActionItems = [
  {
    dataDialog: "modify-dialog",
    title: "Módosít",
    dialogTitle: "Számla módosítása",
    icon: <EditIcon fontSize="small" color="primary" />,
    canShow: (row) => "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <ModifyIncoming {...props} close={close} />
    ),
  },
  {
    dataDialog: "receive-dialog",
    title: "Befogad",
    dialogTitle: "Számla befogadása",
    icon: <EditIcon fontSize="small" color="primary" />,
    canShow: (row) => "RECEIVED" === row.state,
    actionComponent: (props, close) => (
      <ModifyIncoming {...props} close={close} />
    ),
  },
  {
    dataDialog: "close-dialog",
    title: "Lezárás",
    dialogTitle: "Számla Lezárása",
    canShow: (row) =>
      "PAID" !== row.state &&
      "CLOSED" !== row.state &&
      "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <ClosePayable
        {...props}
        close={close}
        path={"/api/manualclose/payable"}
        isClose={true}
        confirm={"Biztos hogy le szeretnéd zárni?"}
        comp={<IncomingBillRow {...props} />}
      />
    ),
  },
  {
    dataDialog: "close-dialog",
    title: "Újranyitás",
    dialogTitle: "Számla Újranyitása",
    canShow: (row) => "CLOSED" === row.state && "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <ClosePayable
        {...props}
        close={close}
        path={"/api/manualclose/payable"}
        isClose={false}
        confirm={"Biztos hogy újra szeretnéd nyitni?"}
        comp={<IncomingBillRow {...props} />}
      />
    ),
  },
  {
    dataDialog: "detail-dialog",
    title: "Részletek",
    dialogTitle: "Részletek",
    width: "lg",
    icon: <FilterListIcon fontSize="small" color="primary" />,
    actionComponent: (props, close) => (
      <PayableDetail
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    divider: true,
  },
  {
    dataDialog: "new-insurance-dialog",
    title: "Biztosítás",
    dialogTitle: "Biztosítás",
    icon: <BeenhereIcon fontSize="small" color="primary" />,
    canShow: (row) => "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <NewCarInsurance {...props} close={close} />
    ),
  },
  {
    divider: true,
  },
  {
    dataDialog: "transaction-dialog",
    title: "Tranzakció linkel",
    dialogTitle: "Linkel",
    canShow: (row) => "MATCH_FOUND" === row.state,
    icon: <LinkIcon fontSize="small" color="primary" />,
    actionComponent: (props, close) => (
      <Matcher
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    dataDialog: "transaction-dialog",
    title: "Manuális tranzakció linkel",
    dialogTitle: "Manuális linkel",
    width: "lg",
    icon: <LinkIcon fontSize="small" color="primary" />,
    canShow: (row) => "NEW" === row.state || "INCOMPLETE" === row.state,
    actionComponent: (props, close) => (
      <ManualMatcherForPayable
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    dataDialog: "group-dialog",
    title: "Számla csoportosít",
    dialogTitle: "Számla linkel",
    icon: <LinkIcon fontSize="small" color="primary" />,
    canShow: (row) =>
      "PAID" !== row.state &&
      "CLOSED" !== row.state &&
      !row.groupPublicId &&
      "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <GroupForPayable
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    dataDialog: "remove-group-dialog",
    title: "Csoportból eltávolít",
    dialogTitle: "Csoportból eltávolít",
    icon: <LinkOffIcon fontSize="small" color="primary" />,
    canShow: (row) => row.groupPublicId,
    actionComponent: (props, close) => (
      <RemovePayableFromGroup
        {...props}
        close={close}
        row={props.row}
        billtype={props.tabletype}
      />
    ),
  },
  {
    divider: true,
  },
  {
    dataDialog: "delete-dialog",
    title: "Törlés",
    dialogTitle: "Számla törlése",
    icon: <DeleteIcon fontSize="small" color="primary" />,
    canShow: (row) => "RECEIVED" !== row.state,
    actionComponent: (props, close) => (
      <DeleteObject
        {...props}
        close={close}
        path={"/api/incomingbill"}
        confirm={"Biztos hogy törölni szeretnéd?"}
        comp={<IncomingBillRow {...props} />}
      />
    ),
  },
];
